import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
} from "./styles";

export default function SubEmployerIntro() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    // const responseApi = await dispatch(fetchEmployerSolutions());

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
    const response = isMalaysia ? content_my : content_sg;

    const { solutions, solutionsCard } = response || {};
    setSolutions(solutions);
    setSolutionsCard(solutionsCard);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Post Jobs Now";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerEmployerSignUp() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "solutions",
    });
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      {solutionsCard?.map((cards, cardIndex) => (
        <CardListContainer key={cardIndex} cardNumber={cardIndex}>
          <CardTextContainer>
            <CardText
              type={"title"}
              cardNumber={cardIndex}
              dangerouslySetInnerHTML={{ __html: cards?.title }}
            ></CardText>
            <CardText
              type={"desc"}
              cardNumber={cardIndex}
              dangerouslySetInnerHTML={{ __html: cards?.description }}
            ></CardText>
          </CardTextContainer>

          <CardImage src={cards?.image?.data?.attributes?.url} />
        </CardListContainer>
      ))}
    </GridContainerStyled>
  );
}
